import React, { PropTypes } from 'react';
import { FontIcon, RaisedButton } from 'material-ui';
import ProfileImage from '../../../app-bar/profile-image';
import R from 'ramda';

const TCNewSignUpPost = (props, context) => {
  const {
    post,
    changeRoute,
  } = props;

  return (
    <div style={{ clear: 'both', border: '1px solid #d3d3d3', padding: '10px', borderRadius: '3px', marginTop: '10px' }}>
      <div style={{ display: 'inline-block', width: '50px', cursor: 'pointer' }} onTouchTap={() => context.router.push(`/company/${post.newCompId}`)}>
        <ProfileImage
          className="profile-link-image"
          companySlugName="TourConnect"
          imageUrl={R.propOr('', 'newProfileImg', post)}
          style={{ border: '0.5px solid #D3D3D3' }}
        />
      </div>
      <div
        style={{
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          maxWidth: 'calc(100% - 50px)',
          padding: '0 1%',
          fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
        }}
      >
        <span style={{ cursor: 'pointer', fontSize: '14px', color: 'rgb(0, 188, 212)' }} onTouchTap={() => context.router.push(`/company/${post.newCompId}`)}>{post.newCompName}</span>
        <br/>
        <span>
          <FontIcon
            className="tc-icon-location_on"
            style={{ margin: '0 5px 0 -4px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)' }}
          >
            <span style={{ fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }}>{post.newCompCountry}</span>
          </FontIcon>
        </span>
      </div>
      <div>
        {`A new ${R.propEq('newCompType', 'Contractor', post) ? 'Buyer' : 'Supplier'} just signed up! Would you like to connect with them?`}
        <br/>
        <RaisedButton onTouchTap={() => changeRoute(`/company/${post.newCompId}`)} style={{ marginTop: '7px' }} label="View Profile" primary />
      </div>
    </div>
  );
};

TCNewSignUpPost.propTypes = {
  post: PropTypes.object,
  changeRoute: PropTypes.func,
};

TCNewSignUpPost.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default TCNewSignUpPost;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/postTypes/tCSignUp.jsx